<template>
    <xx-select v-model="areaId" :list="list" value-key="value" v-bind="$attrs" v-on="listeners" placeholder="请选择库区"></xx-select>
</template>

<script>
/**
 * @author 方涛
 *
 * 库区选择器, 根据门店选择库区, 基于 xx-select, 接口: /api/resource/getPoiWhArea
 */

import XxSelect from './index';

export default {
    name: 'XxAreaSelect',
    props: {
        value: {
            required: false
        },
        /**
         * 门店 id
         */
        poiId: {
            required: false
        },
        /**
         * 对接口返回值的处理函数
         */
        responseFilter: {
            type: Function,
            default: res => {
                return res;
            }
        },
        /**
         * 是否默认选择第一条数据
         */
        setDefault: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            areaId: this.value,
            list: []
        };
    },
    components: {
        XxSelect
    },

    watch: {
        poiId() {
            this.areaId = Array.isArray(this.areaId) ? [] : '';
            this.fetchData();
        },
        areaId: {
            deep: true,
            handler(v, ov) {
                this.$emit('input', v);
                /**
                 * 切换库区时的回调 (value, item)
                 *
                 * @event change
                 * @type {value, item}
                 */
                this.$emit('change', v, this.list.find(item => item.value === v));
            }
        },
        value(v) {
            this.areaId = v;
        }
    },
    computed: {
        listeners() {
            const { change, ...listeners } = this.$listeners;
            return listeners;
        }
    },
    created() {
        if (this.poiId) {
            this.fetchData();
        }
    },
    methods: {
        fetchData() {
            return this.$post({
                url: `${location.origin}/api/resource/getPoiWhArea`,
                body: {
                    poiId: this.poiId
                }
            }).then(res => {
                let ret = (res || []).map(item => {
                    return Object.assign({}, item, {
                        label: item.areaName,
                        value: item.areaId
                    });
                });

                this.list = this.responseFilter(ret);
                if (this.setDefault) {
                    this.areaId = this.list[0].value;
                }
            });
        }
    }
};
</script>
